export default __webpack_public_path__ + "static/media/csvView.6751f800.svg";